import React, { useEffect, useState } from 'react';
import { getPartner } from '../../../utils/getter';

interface ImageProps {
  src: string;
  defaultImage: React.FC<{ className?: string }>;
  className?: string;
  fallbackSrc?: string;
}

const Image: React.FC<ImageProps> = ({
  src,
  defaultImage,
  className,
  fallbackSrc,
}) => {
  const partner = getPartner();
  const primaryImagePath = `/theme/${partner}/images/${src}`;
  const [currentImagePath, setCurrentImagePath] = useState(primaryImagePath);
  const [useDefaultImage, setUseDefaultImage] = useState(false);

  useEffect(() => {
    setCurrentImagePath(primaryImagePath);
    setUseDefaultImage(false);
  }, [primaryImagePath, src, defaultImage, className, partner, fallbackSrc]);

  if (useDefaultImage) {
    const DefaultImage = defaultImage;
    return <DefaultImage className={className} />;
  }

  return (
    <div className={className}>
      <img
        src={currentImagePath}
        alt={src}
        onError={() => {
          if (fallbackSrc && currentImagePath !== fallbackSrc) {
            setCurrentImagePath(fallbackSrc);
            return;
          }
          setUseDefaultImage(true);
        }}
      />
    </div>
  );
};

export default Image;
